import React from 'react';

const RegisterPage = () => (
    <div>
        <h3>Register</h3>
    </div>
)

export default RegisterPage


// WEBPACK FOOTER //
// ./src/pages/RegisterPage.js